/**
 * Feito pelo agente netexperts
 * Módulo: AnalyticsObra — Tab Recebidos (realização de caixa por competência)
 * Data: 2026-06-14
 */
import { useObraArea } from '../hooks/useObraAnalytics'
import { DETAIL_CONFIG } from '../config/areaAnalytics'
import { formatCurrency, formatNumber } from '../../../../utils/obraAnalytics'
import KpiCard from '../../../../Components/Analytics/KpiCard'
import MetricCard from '../components/MetricCard'
import RecebidosMensalPanel from '../components/RecebidosMensalPanel'
import DrillDownTable from '../components/DrillDownTable'
import TabState from '../components/TabState'

const RecebidosTab = ({ obraId, investidor, period }) => {
    const { data, loading, error } = useObraArea(obraId, 'recebidos', { inicio: period.inicio, fim: period.fim }, investidor)

    if (loading || error || !data) return <TabState loading={loading} error={error} />

    const c = data.cards
    const serieMensal = data.serieMensal || []

    return (
        <div className="space-y-6">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                <MetricCard
                    title="Depositado"
                    value={Number(c.total_recebido || 0)}
                    format={formatCurrency}
                    subtitle="Caixa no período"
                />
                <KpiCard
                    title="Recebimentos"
                    value={formatNumber(c.parcelas || 0)}
                    subtitle="Lançamentos no período"
                />
                <MetricCard
                    title="Ticket médio"
                    value={Number(c.ticket_medio || 0)}
                    format={formatCurrency}
                    subtitle="Média por recebimento"
                />
                <MetricCard
                    title="Maior depósito"
                    value={Number(c.maior_recebimento || 0)}
                    format={formatCurrency}
                    subtitle="Maior lançamento do período"
                />
            </div>

            <RecebidosMensalPanel serie={serieMensal} />

            <DrillDownTable
                obraId={obraId}
                area="recebidos"
                investidor={investidor}
                config={DETAIL_CONFIG.recebidos}
                period={period}
            />
        </div>
    )
}

export default RecebidosTab
